module.exports = __webpack_public_path__ + "static/logo-7506ca9f6bd88dff51061cef1350bff2.png";